import React, { useEffect, useState } from 'react';
import { ContainerClient } from '@azure/storage-blob';
import { DateTimeFormatter } from 'brock-date-time';
import { ErrorAlert, PadContainer, Title, VerticalFlex } from 'smartsuite-ui';
import Footer from './Footer';
import PasswordModal from './PasswordModal';

const webEndpointUri = 'https://lhrdocumentstorage.z5.web.core.windows.net';
const containerUri = 'https://lhrdocumentstorage.blob.core.windows.net/$web';

function getFileName(path) {
    if (path.startsWith('/')) {
        path = path.substring(1);
    }

    if (path.endsWith('/')) {
        path = path.substring(0, path.length - 1);
    }

    const idx = path.lastIndexOf('/');
    if (idx > 0) {
        path = path.substring(idx + 1);
    }

    return path;
}

function fromBlobPrefix(path, prefix) {
    return {
        isFile: false,
        name: getFileName(prefix.name),
        path: '/' + prefix.name,
    };
}

function fromBlobItem(path, blob) {
    return {
        isFile: true,
        name: getFileName(blob.name),
        uri: webEndpointUri + '/' + blob.name,
        modified: blob.properties.lastModified,
        size: blob.properties.contentLength ?? 0,
    };
}

function Documents() {
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [contents, setContents] = useState(null);
    const [isPasswordEntered, setIsPasswordEntered] = useState(false);

    useEffect(() => {
        if (!isPasswordEntered) {
            return;
        }

        let cancelled = false;

        async function getContents(path) {
            const container = new ContainerClient(containerUri);
            const prefix = path.substring(1);
            const blobs = container.listBlobsByHierarchy('/', { prefix });

            let contents = [];
            for await (const blob of blobs) {
                const item =
                    blob.kind === 'prefix'
                        ? fromBlobPrefix(path, blob)
                        : fromBlobItem(path, blob);
                contents.push(item);
            }
            return contents;
        }

        async function fetchContents() {
            const contents = await getContents('/');
            if (!cancelled) {
                setContents(contents);
            }
        }

        setContents(null);
        fetchContents();

        return () => {
            cancelled = true;
        };
    }, [isPasswordEntered]);

    function renderBody() {
        if (isModalOpen) {
            return null;
        }

        if (!isPasswordEntered) {
            return <ErrorAlert>Access Denied</ErrorAlert>;
        }

        return (
            <>
                <Title>Please Pick Your Document</Title>
                {contents ? (
                    contents.map((item) => (
                        <div className="documents__grid" key={item.uri}>
                            <a href={item.uri} target="_blank" rel="noreferrer">
                                {item.name}
                            </a>
                            <span>
                                {DateTimeFormatter.dateTime(item.modified)}
                            </span>
                        </div>
                    ))
                ) : (
                    <div>Loading...</div>
                )}
            </>
        );
    }

    return (
        <div className="container pad-container pad-container--no-pad-top-bottom">
            <VerticalFlex cssClassModifiers={['align-center']}>
                <span className="app-title">Welcome to SmartSuite</span>
            </VerticalFlex>
            {renderBody()}
            <VerticalFlex cssClassModifiers={['align-center']}>
                <PadContainer />
                <PadContainer />
                <Footer />
            </VerticalFlex>
            {isModalOpen && (
                <PasswordModal
                    closeModal={() => setIsModalOpen(false)}
                    submitPassword={() => setIsPasswordEntered(true)}
                />
            )}
        </div>
    );
}

export default Documents;
